<template>
    <form  action="" method="POST" class="" v-on:submit.prevent="submit()">
        <div class="form-row">
            <div class="form-group col-12 col-md-6 text-left">
            <label for="company">
                Nome da empresa
            </label>
            <input v-model="company" v-bind:class="{ error: this.company == '' && submited }" type="text" autofocus="autofocus" class="form-control form-control-lg" required>
            </div>
            <div class="form-group col-12 col-md-6 text-left">
            <label for="to">
                Email da empresa
            </label>
            <input v-model="to" v-bind:class="{ error: this.to == '' && submited }" type="email" autofocus="autofocus" class="form-control form-control-lg" required>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12 col-md-6 text-left">
            <label for="contactName">
                Nome do responsável
            </label>
            <input v-model="contact" v-bind:class="{ error: this.contact == '' && submited }" type="nomeResponsavel" autofocus="autofocus" class="form-control form-control-lg" required>
            </div>
            <div class="form-group col-12 col-md-6 text-left">
            <label for="phone">
                Telefone (opcional)
            </label>
            <input v-model="phone" type="telefone" autofocus="autofocus" class="form-control form-control-lg">
            </div>
        </div>
        <div class="form-group text-left">
            <label for="msg">
            Mensagem
            </label>
            <textarea v-model="msg" v-bind:class="{ error: this.msg == '' && submited }" name="mensagem"  class="form-control" id="mensagem" rows="5" required></textarea>
        </div>
        <button type="submit" class="btn btn-primary btn-lg">
            Enviar
        </button>
    </form>
</template>

<style lang="scss" scoped>
    .error {
        border-color: red;
    }
    input, textarea {
        box-shadow: none;
    }
</style>

<script>
    import ApiClient from '../../utils/api-client';

    export default {
        components: { },
        data() {
            return {
                to: "",
                company: "",
                msg: "",
                contact: "",
                phone: "",
                submited: false
            }
        },
        methods: {
            submit() {
                this.submited = true;

                if(!this.isNullOrEmpty(this.to) &&
                    !this.isNullOrEmpty(this.msg) &&
                    !this.isNullOrEmpty(this.company) &&
                    !this.isNullOrEmpty(this.contact)) {
                        ApiClient.inviteCompany(this.to, this.msg, this.company, this.contact, this.phone) 
                            .then((result) => {
                                if (result.status == 200) {
                                    this.$emit("finished");
                                } else {
                                    this.$emit("finished");
                                }
                            })
                            .catch(() => {

                            });
                }
            },

            isNullOrEmpty(value) {
                if (value == null || value == '')
                    return true;
                
                return false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Invite/Company.vue